import * as React from 'react'
import { Column } from '../types'
import SettingsHiddenInputs from './settings_hidden_inputs'
import ColumnOptionsHiddenInputs from './column_options_hidden_inputs'

interface ColumnHiddenInputsProps {
  column: Column
  index: number
}

export default function ColumnHiddenInputs({ column, index }: ColumnHiddenInputsProps) {
  const prefix = `project_group[columns_attributes][${index}]`
  const isExisting = typeof column.id === 'number'
  const isSelectColumn = column.type === 'Projects::Columns::Select'

  if (column._destroy) {
    return (
      <span>
        {isExisting && <input type="hidden" name={`${prefix}[id]`} value={column.id} />}
        <input type="hidden" name={`${prefix}[_destroy]`} value="1" />
      </span>
    )
  }

  return (
    <span>
      {isExisting && <input type="hidden" name={`${prefix}[id]`} value={column.id} />}
      <input type="hidden" name={`${prefix}[type]`} value={column.type} />
      <input type="hidden" name={`${prefix}[key]`} value={column.key} />
      <input type="hidden" name={`${prefix}[label]`} value={column.label} />
      <input type="hidden" name={`${prefix}[position]`} value={column.position} />
      <input
        type="hidden"
        name={`${prefix}[required]`}
        value={column.required ? 'true' : 'false'}
      />
      <input
        type="hidden"
        name={`${prefix}[system_column]`}
        value={column.system_column ? 'true' : 'false'}
      />
      {column.color && (
        <input type="hidden" name={`${prefix}[color]`} value={column.color} />
      )}
      <SettingsHiddenInputs prefix={prefix} settings={column.settings} />
      {isSelectColumn && column.column_options && (
        <ColumnOptionsHiddenInputs prefix={prefix} options={column.column_options} />
      )}
    </span>
  )
}
